import $ from 'jquery';

$(function(){
	// Mobile Navigation
	$('.lines-button').click(function(){
		$('body').toggleClass('no-scroll');
		$( '.menu' ).toggle();
		$( '.quit' ).toggle();
		$('#primary-menu').toggleClass('open');
		$(this).toggleClass('close-burger');
		//$('.sb-right').toggleClass('sb-active');
		//$('#sb-site').toggleClass('active');
	});
	// Submenu Navigation
	$('.has-submenu').click(function(){
		$(this).children('.submenu').fadeToggle( "fast", "linear" );
	});
		
	// Search Pop Show/Hide
	$('.search-button').click(function(){
		$('form#search').toggleClass('visible');
	});
});